import {
  PAYER_SIGNATURE_OPTION_VALUES,
  payerSignatureOptions,
} from './payerSignatureOptions';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';


export const payerSignatureToPayerSignatureOption = (
  signatureRequired: any
) => {
  let key: PAYER_SIGNATURE_OPTION_VALUES;
  if (signatureRequired === null) {
    key = PAYER_SIGNATURE_OPTION_VALUES.ORG_DEFAULT;
  } else {
    key = signatureRequired
      ? PAYER_SIGNATURE_OPTION_VALUES.YES
      : PAYER_SIGNATURE_OPTION_VALUES.NO;
  }

  return payerSignatureOptions.find(
    (option) => option.value === key
  ) as SelectOption;
};
